<template>
  <v-card
    class="mx-auto pa-0"
    :color="color"
    :dark="dark"
    :outlined="true"
  >
    <v-card-title
      v-if="showTitleBar"
      class="d-flex py-2 xCardTitle"
    >
      <div class="text-overline">{{ title }}</div>
      <v-spacer></v-spacer>
      <v-tooltip
        left
        dark
        v-if="mode == 'edit'"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            color="secondary"
            @click="edit()"
            small
            icon
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Redigera</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text
      :dark="dark"
      class="pa-0"
    >
      <v-simple-table class="xSimpleTable">
        <template v-slot:default>
          <tbody>
            <tr
              v-for="(data, index) in dataWithValue_ar"
              :key="index"
            >
              <td>
                <div class="text-subtitle-2">{{ data.name }}</div>
              </td>
              <td>
                <div
                  v-for="(value, index) in data.value_ar"
                  :key="index"
                  class="text-body"
                >
                  {{ value }}
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    data_ar: {
      type: Array,
      required: true
    },
    color: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'edit'
    }
  },
  data: () => ({
  }),
  computed: {
    showTitleBar() {
      return this.mode == 'edit' || this.title.length
    },
    dataWithValue_ar() {
      return this.data_ar.filter((element) => {
        return element.hasValue
      })
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    }
  }
}
</script>

<style>

</style>